import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from './store';
import { BaseService } from '../core/base.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Product } from '../product/product';
import { Link, OnboardingLink } from './onboarding/onboarding-link';
import { OnboardingStatus } from './onboarding/onboarding-status';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoreService extends BaseService<Store> {
  onboardingApi = '';

  constructor(protected override readonly httpClient: HttpClient) {
    super(httpClient);
    this.onboardingApi = this.apiUrl + 'onboarding';
    this.apiUrl += 'stores';
  }

  getUserStore(): Observable<Store> {
    return this.httpClient
      .get<Store>(`${this.apiUrl}/store/user`, this.HTTP_OPTIONS)
      .pipe(catchError(() => EMPTY));
  }

  getUserStoreProducts(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(
      `${this.apiUrl}/store/user/products`,
      this.HTTP_OPTIONS
    );
  }

  getDashboardLink(): Observable<Link> {
    return this.httpClient.get<Link>(
      `${this.apiUrl}/dashboard`,
      this.HTTP_OPTIONS
    );
  }

  getOnboardingLink(): Observable<OnboardingLink> {
    return this.httpClient.get<OnboardingLink>(
      `${this.onboardingApi}/link`,
      this.HTTP_OPTIONS
    );
  }

  getOnboardingStatus(): Observable<OnboardingStatus> {
    return this.httpClient.get<OnboardingStatus>(
      `${this.onboardingApi}/status`,
      this.HTTP_OPTIONS
    );
  }

  createStoreProduct(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(
      `${this.apiUrl}/product`,
      product,
      this.HTTP_OPTIONS
    );
  }

  updateStoreProduct(product: Product): Observable<Product> {
    return this.httpClient.put<Product>(
      `${this.apiUrl}/product/${product?.id}`,
      product,
      this.HTTP_OPTIONS
    );
  }

  getImageUrlCached(store: Store): string {
    if (store.id && store.image_location && store.image_location != '') {
      return `${environment.imageURL}/stores/${store?.id}/image/${store.image_location}`;
    }
    return 'assets/images/no-store-image.svg';
  }
}
